import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { retry, catchError, map } from 'rxjs/operators'

@Injectable({
  providedIn: 'root'
})
export class ClientServiceService {
apiURL = 'https://www.seotunersorders.com/webapis/api.php';
  constructor(private http: HttpClient) { }
  
   getClients(vendor_email): Observable<any> {
    return this.http.get<any>(this.apiURL + '?action=all-clients&vendor_email='+vendor_email)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }
   getProducts(): Observable<any> {
    return this.http.get<any>(this.apiURL + '?action=product-list-drop')
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }
   SubmitDeleteForm(orders): Observable<any> 
  {
    return this.http.post<any>(`${this.apiURL}`, {orders: orders, action:"delete_orders"})
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }
  getVendorOrders(vendor_email, per_page, current_page, start_date, end_date): Observable<any> {
    return this.http.get<any>(this.apiURL + '?action=all-orders&vendor_email='+vendor_email+'&per_page='+per_page+'&current_page='+current_page+'&start_date='+start_date+'&end_date='+end_date)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  getOrderNum(): Observable<any> {
    return this.http.get<any>(this.apiURL + '?action=gen_order')
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }
    getClientDetails(email): Observable<any> {
    return this.http.get<any>(this.apiURL + '?action=client-details&email='+email)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }
   getOrderDetails(id): Observable<any> {
    return this.http.get<any>(this.apiURL + '?action=order-details&id='+id)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  getEditOrderData(id): Observable<any> {
    return this.http.get<any>(this.apiURL + '?action=edit-order-data&id='+id)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

   getProductDetails(id): Observable<any> {
    return this.http.get<any>(this.apiURL + '?action=product-details&id='+id)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }
  
   SubmitForm(order): Observable<any> {
    return this.http.post<any>(`${this.apiURL}`, {order: order,action:"submitform"})
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  updateOrder(order, order_id): Observable<any> 
  {
    return this.http.post<any>(`${this.apiURL}`, {order: order, order_id: order_id, action:"updateorder"})
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }


  SubmitSignForm(customer,payment,sign,verify_code): Observable<any> {
    return this.http.post<any>(`${this.apiURL}`, {customer: customer, payment: payment,sign:sign,verify_code:verify_code,action:"submitsignform"})
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  SubmitPasswordForm(userForm): Observable<any> 
  {
    userForm.action = "update_password";
    return this.http.post<any>(`${this.apiURL}`, userForm)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  resetPasswordEmail(email): Observable<any> 
  {
    return this.http.get<any>(this.apiURL + '?action=reset_password_email&email='+email)
    .pipe(
      retry(1),
      catchError(this.handleError)
    )
  }

  handleError(error) 
  {
     let errorMessage = '';
     if(error.error instanceof ErrorEvent) {
       // Get client-side error
       errorMessage = error.error.message;
     } else {
       // Get server-side error
       errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
     }
     window.alert(errorMessage);
     return throwError(errorMessage);
  }
}
